import { download } from './download';

export const subtitles = {
  download,
};
